import React from "react";
import { QuestionManagement } from "@components/Question";

export default function QuestionIndex() {
  return <QuestionManagement />;
}
